<template>
  <b-modal
    :id="'carfax-notes-modal' + carfax.id"
    :ref="'carfax-notes-modal' + carfax.id"
    modal-class="modal-fullscreen"
    centered
    no-close-on-backdrop
    scrollable
    title="Carfax notes"
    size="lg"
    hide-footer
    @show="getCarfaxNotes()"
    @hidden="resetForm()"
  >
    <VehicleDetails
      v-if="vehicle"
      :vehicle="vehicle"
      :color="vehicle.vehicleInformation.color || '----'"
    />
    <NoteRegistrationForm
      v-if="userHasPermission('carfax', 'write')"
      :vehicle="vehicle"
      :refreshData="getCarfaxNotes"
      :carfax="carfax"
    />
    <b-list-group v-if="!notes" class="mt-2">
      <b-list-group-item class="text-center">
        <b-spinner variant="yellow" />
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-else class="mt-2 mb-2 note-list" tag="ul">
      <b-list-group-item v-if="notes && !notes.length" class="text-center">
        <b>No notes to show</b>
      </b-list-group-item>

      <b-list-group-item
        v-for="(note, i) in notes"
        :key="i"
        class="flex-column align-items-start"
        tag="li"
      >
        <NoteCard :note="note" :refreshData="getCarfaxNotes" />
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { GET_CARFAX_NOTES } from "./actions";
import { superAdminMixin } from "@/modules/superAdmin/mixins.js";
import NoteRegistrationForm from "./RegistrationForm";
import VehicleDetails from "@/modules/superAdmin/components/VehicleDetails.vue";
import NoteCard from "./NoteCard.vue";
export default {
  name: "CarfaxNotesModal",
  components: { NoteRegistrationForm, VehicleDetails, NoteCard },
  mixins: [superAdminMixin],
  props: ["carfax"],
  computed: {
    ...mapState({
      vehicle: (state) => state.superAdminStore.vehicle,
      /*   notes: (state) => state.vehicle.carfax.notes.notes, */
    }),
  },
  data() {
    return {
      notes: null,
    };
  },
  mounted() {},
  methods: {
    resetForm() {},
    changePage(page) {
      this.$store.commit(GET_CARFAX_NOTES, {
        fields: { page },
      });
      this.getNotes();
    },
    getCarfaxNotes() {
      this.$store
        .dispatch(GET_CARFAX_NOTES, {
          id: this.carfax.id,
        })
        .then((response) => {
          this.notes = [];
          this.notes = response.carfaxNote;
          this.$parent.getCarfaxNotes();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.resize-none {
  resize: none;
}
.note-list {
  max-height: 500px;
  overflow-y: auto;
}
</style>
